import type { AdminVmLimits, GeneralSettings } from "@warrenio/api-spec/spec.oats.gen";

export const adminConfigPaymentExample: GeneralSettings = {
    first_account_credit: 20,
    min_topup_amount: 20,
    default_active_post_payment_level: "LIMITED",
    restriction_level_clear_topup_threshold: 25,
    restriction_level_thresholds: [
        {
            days: 14,
            restriction_level: "FROZEN",
        },
        {
            days: 7,
            restriction_level: "TERMINATED",
        },
    ],
    low_balance_notice_threshold: 25,
};

export const adminConfigVmExample: AdminVmLimits = {
    vcpu: 2,
    ram_mb: 2048,
};
